import styled from 'styled-components';

export const StyledMedicalInformationDescriptionPlaceholder = styled.span`
    color: ${(props) => props.theme.placeholder};
}`;
StyledMedicalInformationDescriptionPlaceholder.displayName = 'StyledMedicalInformationDescriptionPlaceholder';
